module.exports = __webpack_public_path__ + "static/media/discover-screenshot-bts-army.0a157c2f.png";